import React from 'react';
import {OrbitComponent} from '../../base-components/orbit-component/orbit-component';
import {CmsContentDecorator} from '../../../services/cms/cms-content-decorator/cms-content-decorator';
import {observer} from 'mobx-react';
import {CmsBannerId} from '../../../services/cms/cms-banners/cm-banner-id/cms-banner-id';

export interface BannerContentComponentProps {
  html: string;
  bannerId: CmsBannerId;
}

@observer
export class BannerContentComponent extends OrbitComponent<BannerContentComponentProps> {

  componentWillUnmount() {
    super.componentWillUnmount();
    this._disposeBannerContentDecorator();
  }

  componentDidUpdate() {
    this._redecorateBannerContent();
  }

  private _disposeBannerContentDecorator() {
    if(this._bannerContentDecorator) {
      this._bannerContentDecorator.dispose();
      this._bannerContentDecorator = null;
    }
  }

  private _redecorateBannerContent() {
    this._disposeBannerContentDecorator();
    if(this._bannerContentElementRef) {
      this._bannerContentElementRef.innerHTML = this.props.html;
      this._bannerContentDecorator = new CmsContentDecorator(this._bannerContentElementRef, this.services);
    }
  }

  private _bannerContentDecorator: CmsContentDecorator | null = null;

  private _bannerContentElementRef: HTMLSpanElement | null = null;

  private _captureBannerContentElementRef = (element: HTMLSpanElement | null) => {
    this._bannerContentElementRef = element;
    this._redecorateBannerContent();
  };

  render() {
    return (<span ref={this._captureBannerContentElementRef}></span>);
  }
}
